import api from '../node_modules/js-cookie/dist/js.cookie.js';

const CONSENT_TYPES = [
    'OneTrust_TargetingCookies',
    'OneTrust_FunctionalCookies',
    'OneTrust_PerformanceCookies',
];
const getConsentValues = () => {
    return CONSENT_TYPES.map((c) => `${c}:${api.get(c) || 'NO'}`);
};

export { CONSENT_TYPES, getConsentValues };
//# sourceMappingURL=consentCookieService.js.map
